import { render, staticRenderFns } from "./InstallerData.vue?vue&type=template&id=732c0722&scoped=true&"
import script from "./InstallerData.vue?vue&type=script&lang=ts&"
export * from "./InstallerData.vue?vue&type=script&lang=ts&"
import style0 from "./InstallerData.vue?vue&type=style&index=0&id=732c0722&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732c0722",
  null
  
)

export default component.exports